import { WrongSecretError } from '@curentia/shared';
import { ApiError } from './api';
import { DeviceError } from './device';
import { PracticeError } from './records';

const MESSAGES: Record<string, string> = {
  account_exists: 'An account of this kind already uses this mobile number. Sign in instead.',
  invalid_credentials: 'The mobile number or password is wrong.',
  rate_limited: 'Too many attempts. Wait a few minutes and try again.',
  reset_refused: 'This device could not reset the password. It may have been removed from your account.',
  abha_number_in_use: 'This ABHA number is already linked to another account.',
  abha_address_in_use: 'This ABHA address is already linked to another account.',
  practice_not_found: 'You are not a member of this practice.',
  invitation_not_found: 'This code is not valid or was already used. Ask the practice for a new one.',
  already_member: 'You are already a member of this practice.',
  last_admin: 'A practice needs at least one practice admin. Make someone else an admin first.',
  solo_exists: 'You already have a solo practice.',
  too_many_pending: 'Wait for your other practices to be verified first.',
  practice_inactive: 'This practice is not active, so this cannot be done now.',
  link_exists: 'You already asked to link this pharmacy.',
  not_a_member: 'You are no longer a member of this practice.',
  pairing_not_found: 'This pairing code is not valid or was already used.',
  link_code_not_found: 'This code is not valid or was already used. Ask the patient to make a new one.',
  not_linked: 'Link the patient’s Curentia account to this practice first.',
  not_clinical: 'Only clinics, hospitals and solo practices link patients.',
  consent_required: 'The patient’s approval does not cover this.',
};

/** A message fit to show for any error a screen action can throw. */
export function messageFor(error: unknown): string {
  if (error instanceof WrongSecretError) return 'That password or recovery code is not right.';
  if (error instanceof ApiError) {
    if (error.code === 'invalid_request' && Array.isArray(error.extra.issues)) {
      const first = error.extra.issues[0] as { message?: string } | undefined;
      if (first?.message) return first.message;
    }
    if ((error.code === 'account_rejected' || error.code === 'account_suspended') && typeof error.extra.reason === 'string') {
      return `${error.message}: ${error.extra.reason}`;
    }
    return MESSAGES[error.code] ?? error.message;
  }
  if (error instanceof DeviceError || error instanceof PracticeError) return error.message;
  if (error instanceof Error && error.message.includes('not a Curentia backup')) return error.message;
  return 'Something went wrong. Try again.';
}
